import React from "react"

import { isNullOrUndefined, localizedDate } from "../../utils"

import TextHighlights from "./TextWithHighlight"

export default class ResultText extends React.Component {
  /**
   * Render text without truncation
   */


  renderNotTruncated = () => {
    const { text, attributes } = this.props
    // console.log(attributes.answer.StringValue)
    const answer = attributes?.hasOwnProperty('answer') ? attributes.answer.StringValue : ""
    const plan = attributes?.hasOwnProperty('plan') ? attributes.plan.StringValue : ""
    const state = attributes?.hasOwnProperty('answer') ? attributes.state.StringValue : ""
    const counties = attributes?.hasOwnProperty('counties') ? attributes.counties.StringListValue : ""
    // console.log(attributes[0])
    return (
      <span>
        {/* <TextHighlights textWithHighlights={res} /> */}
        {answer}
        <div style={{padding: '10px', backgroundColor: '#ccc'}}>
        <p>Plan: {plan}</p>
        <p>State: {state}</p>
        <p>
        Counties: {counties}
        </p>
        </div>
      </span>
    )
  }

  renderResult = () => {
    const { text } = this.props

    if (isNullOrUndefined(text)) {
      return null;
    } else {
      return this.renderNotTruncated(text)
    }
  }

  formatDateString = (dateStr) => {
    const date = localizedDate(new Date(dateStr), {
      day: "2-digit",
      month: "short",
      year: "numeric"
    })

    return `${date} - `;
  };

  // getStringAfterFirstQuestionMark(inputString) {
  //   const questionMarkIndex = inputString.indexOf('?');
  
  //   if (questionMarkIndex !== -1) {
  //     // Add 1 to start the substring after the question mark
  //     return inputString.substring(questionMarkIndex + 1);
  //   } else {
  //     // If no question mark is found, return the original string
  //     return inputString;
  //   }
  // }

  render() {
    const { lastUpdated } = this.props;

    const date = lastUpdated ? this.formatDateString(lastUpdated) : undefined

    return (
      <div className={this.props.className}>
        {date && <span>{date} </span>}
        <span>{this.renderNotTruncated()}</span>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Kendra/resultsPanel/components/ResultText.js